import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SimpleMessage } from './simple-inline-message.model';
import { CommonModule } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'miq-simple-inline-message',
  styleUrls: ['./simple-inline-message.component.scss'],
  imports: [CommonModule],
  template: `
    <div *ngIf="messageList?.length" class="miq-sim__container">
      <div *ngFor="let msg of messageList" class="miq-sim-message__wrapper">
        <div class="miq-sim__message" [ngClass]="msg.class">
          {{ msg.text }}
        </div>
      </div>
    </div>
  `,
})
export class SimpleInlineMessageComponent {
  private _messagesFormated = null;

  @Input() set messageList(messageList: SimpleMessage[]) {
    this._messagesFormated = messageList.map(msg => ({ ...msg, class: this.#getMsgClass(msg) }));
  }
  get messageList() {
    return this._messagesFormated;
  }

  #getMsgClass(msg: SimpleMessage) {
    let c = `miq-sim__message--${msg.type}`;
    if (msg.fontVariant) {
      c = c.concat(` miq-sim__message--${msg.fontVariant}`);
    }
    return c;
  }
}
